import { Component, OnInit } from '@angular/core';
import { PostService } from "../../Services/post.service"
import { LocationService } from "../../Services/location.service";

import {location} from '../../shared/interfaces/location.interface';
@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {
  showLocationForm: boolean;
  locations = [];
  location: location;


  constructor(private locationService: LocationService) {
    this.location = {} as any;
    this.showLocationForm = false;
    this.locationService.getLocations().subscribe(location => {
      this.locations = location;
      console.log(location);

    }, (error) => { console.log('error was not caught')});
  }


  ngOnInit() {
  }

  toggleAddLocation() {
    if (this.showLocationForm) {
      this.showLocationForm = false;
    } else {
      this.showLocationForm = true;
    }

  }

  loadLocation(code) {
    console.log("dbl");
    this.locationService.getLocation(code).subscribe(response => {
      console.log("response" + response);
      this.showLocationForm = true;
      this.location = response;
    })
  }

  cancel() {
    this.showLocationForm = false;
    this.location = {} as location;
  }

  save() {
    console.log(this.location);
    this.locationService.postLocation(this.location).subscribe(response => { 
      this.updateLocationInList();
    }, (err) => { 
      console.log(err);
      if (err.status == 422 && err._body == 'Duplicate Location') { 
        this.locationService.putLocation(this.location).subscribe(response => { 
         this.updateLocationInList();
        });
      }
    });
    
  }

  updateLocationInList() { 
    this.locations.forEach(location => {
      if (location.code == this.location.code) {
        this.locations.splice(this.locations.indexOf(location, 0), 1);
      }
    });
    this.locations.push(this.location);
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/location/location.component.ts